import React from "react";
import { Typography } from "antd";

interface PendingChangeNoteProps {
  children?: React.ReactNode;
}

// Shared "Pending — not yet saved" indicator for editable fields with a
// staged-but-unsaved draft value. Purely presentational — callers decide
// when to render it based on their own draft-vs-original comparison.
export const PendingChangeNote: React.FC<PendingChangeNoteProps> = ({
  children = "Pending — not yet saved",
}) => (
  <Typography.Text type="warning" style={{ fontSize: 12 }}>
    {children}
  </Typography.Text>
);
